import {
    SEND_LOAN_OFFICER_VERIFY_EMAIL_OTP,
    CONFIRM_LOAN_OFFICER_EMAIL_OTP,
    UPDATE_LOAN_OFFICER_DATA,
    LOAN_OFFICER_LOGIN,
    FORGOT_LOAN_OFFICER_PASSWORD,
    GET_LOAN_OFFICER_INFORMATION_BY_LOAN_OFFICER_ID,
    GET_LOAN_OFFICER_DASHBOARD_SUMMARY,
    GET_APPLICATION_REVIEW_COMMENT_FOR_LOAN_OFFICER,
    GET_REVIST_APPLICATION_LIST_BY_LOANOFFICER_ID,
    CHANGE_LOAN_OFFICER_PASSWORD,
    GET_ALL_LOAN_APPLICATION_LIST_BY_LOAN_OFFICER_ID,
    FORGOT_PASSWORD_SEND_EMAIL_OTP,
    UPDATE_APPLICANT_STATUS,
    GET_ALL_CAPITAL_PROVIDER_LIST
} from "../constants/constants";
import { instance } from "./apiRequest";

let _capitalProviderService = {
    async sendLoanOfficerVerifyEmailOTP(obj) {
        return await instance.post(SEND_LOAN_OFFICER_VERIFY_EMAIL_OTP, obj);
    },
    async confirmLoanOfficerEmailOTP(obj) {
        return await instance.post(CONFIRM_LOAN_OFFICER_EMAIL_OTP, obj);
    },
    async updateLoanOfficerData(reqObj) {
        return await instance.post(UPDATE_LOAN_OFFICER_DATA, reqObj);
    },
    async forgotPasswordSendEmailOTP(obj) {
        return await instance.post(FORGOT_PASSWORD_SEND_EMAIL_OTP, obj);
    },
    async loanOfficerLogin(obj) {
        return await instance.post(LOAN_OFFICER_LOGIN, obj);
    },
    async forgotLoanOfficerPassword(reqObj) {
        return await instance.post(FORGOT_LOAN_OFFICER_PASSWORD, reqObj);
    },
    async getLoanOfficerInformationByLoanOfficerId(loanOfficerId) {
        let url = GET_LOAN_OFFICER_INFORMATION_BY_LOAN_OFFICER_ID + "?loanOfficerId=" + loanOfficerId;
        return await instance.get(url);
    },
    async getLoanOfficerDashboardSummary(loanOfficerId) {
        let url = GET_LOAN_OFFICER_DASHBOARD_SUMMARY + "?LoanOfficerId=" + loanOfficerId;;
        return await instance.get(url);
    },
    async getApplicationReviewCommentForLoanOfficer(applicationId, loanOfficerId) {
        let url = GET_APPLICATION_REVIEW_COMMENT_FOR_LOAN_OFFICER + "?applicationId=" + applicationId + "&loanOfficerId=" + loanOfficerId;
        return await instance.get(url);
    },
    async getRevistApplicationListByLoanOfficerId({ LoanOfficerId, startDate = "", endDate = "", pageIndex = 1, pageSize = 10, searchTerm = "", sortBy = "id", sortAsc = false }) {
        let url = `${GET_REVIST_APPLICATION_LIST_BY_LOANOFFICER_ID}?LoanOfficerId=${LoanOfficerId}&startDate=${startDate}&endDate=${endDate}&pageIndex=${pageIndex}&pageSize=${pageSize}&searchTerm=${searchTerm}&sortBy=${sortBy}&sortAsc=${sortAsc}`;
        return await instance.get(url);
    },
    async ChangeLoanOfficerPassword(reqObj) {
        return await instance.post(CHANGE_LOAN_OFFICER_PASSWORD, reqObj);
    },
    async getAllLoanApplicationListByLoanOfficerId({
        loanOfficerId, ByAppStatus, startDate, endDate, pageIndex, pageSize, searchTerm, sortBy, sortAsc
    }) {
        let appStatus = ByAppStatus ? ByAppStatus : 0;

        let queryString =
            "?loanOfficerId=" +
            loanOfficerId +
            "&pageIndex=" +
            pageIndex +
            "&pageSize=" +
            pageSize +
            "&ByAppStatus=" +
            appStatus;

        // if (ByAppStatus && ByAppStatus != "") {
        //     queryString = queryString + "&ByAppStatus=" + ByAppStatus;
        // }
        if (searchTerm && searchTerm != "") {
            queryString = queryString + "&searchTerm=" + searchTerm;
        }
        if (startDate && startDate != "" && endDate && endDate != "") {
            queryString = queryString + "&startDate=" + startDate + "&endDate=" + endDate;
        }
        if (sortBy && sortBy != "") {
            let sortBytext = (sortBy == "newest" || sortBy == "oldest") ? "createddate" : "app_det_loanamount";
            queryString = queryString + "&sortBy=" + sortBytext;
        }
        if (sortAsc && sortAsc != "") {
            let sortBytext = (sortBy == "oldest" || sortBy == "high") ? false : true;
            queryString = queryString + "&sortAsc=" + sortBytext;
        }
        return await instance.get(GET_ALL_LOAN_APPLICATION_LIST_BY_LOAN_OFFICER_ID + queryString);
    },
    async updateApplicantStatus(reqObj) {
        return await instance.post(UPDATE_APPLICANT_STATUS, reqObj);
    },
    async getAllCapitalProviderList(reqObj) {
        return await instance.get(GET_ALL_CAPITAL_PROVIDER_LIST, reqObj);
    },

}
export default _capitalProviderService;